import { normalizeUsGameKey, usGameSportForBoard, usPeriodForMarketType, type UsGameSport } from './sports.js';
const object = (v: unknown): Record<string, unknown> | null => v !== null && typeof v === 'object' && !Array.isArray(v) ? v as Record<string, unknown> : null;

/** Exact producer event orientation. Pure shared navigation metadata, never quote or execution authority. */
export interface UsGameIdentity {
  key: string; wireKey: string; sport: UsGameSport; awayCode: string; homeCode: string; startTimeMs: number;
}
export function usEventIdentity(value: unknown): UsGameIdentity | null {
  const r = object(value), teams = object(r?.canonicalTeams);
  if (!r || r.source !== 'polymarket_us' || r.venue !== 'polymarket_us'
    || r.marketType !== 'game' || r.status !== 'open'
    || r.dhAmbiguous === true || typeof r.sportsMarketType !== 'string'
    || usPeriodForMarketType(r.sportsMarketType) !== 'full'
    || r.period !== undefined && r.period !== 'full'
    || typeof r.pmusMarketSlug !== 'string' || !/^[A-Za-z0-9_-]{1,256}$/.test(r.pmusMarketSlug)
    || r.ticker !== `PMUS-${r.pmusMarketSlug}`) return null;
  const base = typeof r.baseSport === 'string' ? r.baseSport : r.sport;
  const sport = typeof base === 'string' ? usGameSportForBoard(base) : null;
  const key = sport ? normalizeUsGameKey(r.canonicalGameKeyV2, sport) : null;
  const away = teams?.away, home = teams?.home;
  const startTimeMs = typeof r.eventStartTime === 'string' ? Date.parse(r.eventStartTime) : NaN;
  if (!sport || !key || !key.startsWith(sport.toLowerCase() + '|') || !Number.isFinite(startTimeMs)
    || typeof away !== 'string' || typeof home !== 'string' || away === home
    || !key.split('|').slice(3).includes(away) || !key.split('|').slice(3).includes(home)) return null;
  return { key, wireKey: r.canonicalGameKeyV2 as string, sport, awayCode: away, homeCode: home, startTimeMs };
}

export function sameUsGameIdentity(a: UsGameIdentity | null, b: UsGameIdentity | null): boolean {
  return a === b || !!a && !!b && a.key === b.key && a.wireKey === b.wireKey && a.sport === b.sport
    && a.awayCode === b.awayCode && a.homeCode === b.homeCode && a.startTimeMs === b.startTimeMs;
}
